import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import InstructionCreatePage from './Create';
import request from '../../utils/request';

const InstructionEditPage: React.FC = () => {
  const params = useParams();
  const id = Number(params.id);

  // 设置标签页标题：指令修改-系统编码
  useEffect(() => {
    (async () => {
      if (!id) return;
      try {
        const resp = await request.get(`/api/v1/instruction/instructions/${id}/`);
        const d = resp?.data || {};
        const code = d?.system_code || d?.systemCode || d?.code || id;
        const title = `指令修改-${code}`;
        try {
          document.title = title;
        } catch {}
        try {
          const w: any = window as any;
          // 缓存到 sessionStorage，供 TabsManager 使用
          try {
            const basePath = (w?.location?.pathname || '').split('?')[0];
            const detailBasePath = basePath.replace(/\/edit$/, '');
            sessionStorage.setItem(`tab_title_instruction:${detailBasePath}`, String(code));
            sessionStorage.setItem(`tab_title_instruction_edit:${basePath}`, String(code));
          } catch {}
          if (w?.tabsManager && typeof w.tabsManager.updateTabTitle === 'function') {
            w.tabsManager.updateTabTitle(title);
          }
        } catch {}
      } catch {}
    })();
  }, [id]);

  // 把要修改的指令ID直接传给创建/编辑页（首次渲染就可用）；key 保证切换到另一个指令时整页重新初始化。
  // 以前是在这里用副作用把 edit_from 写进地址栏、由里层挂载时读一次——生产构建里里层先于外层执行副作用，读不到，
  // 标签页管理器重写地址时还会把这个参数丢掉，所以编辑页不回填；现在不再依赖地址栏。
  const editInstructionId = Number.isFinite(id) && id > 0 ? id : undefined;
  return <InstructionCreatePage key={editInstructionId ?? 'edit'} editInstructionId={editInstructionId} />;
};

export default InstructionEditPage;


